import { emptyValidator, formValidator, numberOnlyValidator, greaterThanZeroValidator } from "../../validators";

const vehicleTypeValidationStatus = {
  vhtType: {
    validators: [emptyValidator()],
    name: "Vehicle Type",
  },
  vhtStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  vhtActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
  vhtMaxCbm: {
    validators: [emptyValidator(), numberOnlyValidator(), greaterThanZeroValidator()],
    name: "Max CBM",
  },
  vhtMaxCbf: {
    validators: [numberOnlyValidator(), greaterThanZeroValidator()],
    name: "Max CBF",
  },
  vhtCarbonFactor: {
    validators: [emptyValidator(), numberOnlyValidator(), greaterThanZeroValidator()],
    name: "Carbon Factor",
  },
  vhtLoadingTime: {
    validators: [numberOnlyValidator(), greaterThanZeroValidator()],
    name: "Loading Time",
  },
  vhtUnloadingTime: {
    validators: [numberOnlyValidator(), greaterThanZeroValidator()],
    name: "Unloading Time",
  },
  vhtDemurrage: {
    validators: [numberOnlyValidator(), greaterThanZeroValidator()],
    name: "Demurrage",
  },
};

export const vehicleTypeValidation = (vehicleType) => {
  return formValidator(vehicleType, vehicleTypeValidationStatus);
};
